module.exports = new __parcel__URL__("buckley-caffeinating.824a444e.png").toString();